import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function EgyediPonyvak() {
  return (
    <SubPageLayout
      eyebrow="Egyedi ponyvák"
      title="Speciális, méretre szabott megoldások."
      intro="Egyedi járművek, lószállítók, targoncák, kocsibeállók, fagyis autók, kabriók és kárpitos munkák – ami másnak lehetetlen, nálunk megoldható. Bármilyen forma, anyag és kiegészítő."
      heroImage="/assets/gallery/egyedi-01.jpg"
      bullets={[
        { title: "Bármilyen forma", text: "Komplex geometriájú, hajlított, lekerekített ponyvák hegesztett varrással." },
        { title: "Speciális járművek", text: "Lószállítók, targoncák, fagyis autók, kabrió tetők, kocsibeállók." },
        { title: "Tervezés Önnel", text: "Helyszíni méretvétel, kiviteli rajzok az indulás előtt." },
        { title: "20+ év know-how", text: "Több ezer egyedi munka mögöttünk – tudjuk, mi jön be." },
      ]}
      gallery={SITE_IMAGES.customGallery}
    />
  );
}
